import type { Ref } from "vue";

export function useSatisfiedCanvassTargets(
  satisfiedCanvassTargetIds: Ref<Array<string>>,
) {
  const canvassTargetIsSatisfied = (id: string) =>
    satisfiedCanvassTargetIds.value.includes(id);

  const toggleSatisfiedCanvassTarget = (toggleId: string) => {
    if (canvassTargetIsSatisfied(toggleId)) {
      satisfiedCanvassTargetIds.value = satisfiedCanvassTargetIds.value.filter(
        (id) => id !== toggleId,
      );
    } else {
      satisfiedCanvassTargetIds.value.push(toggleId);
    }
  };
  return { toggleSatisfiedCanvassTarget, canvassTargetIsSatisfied };
}
